// Tabs for the Managed Services pages. `slug` is used in the URL, e.g. /gcc-odc-solutions/odc-setup-scaling
export interface ManagedServiceTab {
  name: string;
  slug: string;
}

export const SOFTWARE_ENGINEERING_TABS: ManagedServiceTab[] = [
  {name: 'Product Engineering', slug: 'product-engineering'},
  {name: 'Application Development', slug: 'application-development'},
  {name: 'UX/UI Development', slug: 'ux-ui-development'},
  {name: 'Software Testing & QA', slug: 'software-testing-qa'}
];

export const DATA_SERVICES_TABS: ManagedServiceTab[] = [
  {name: 'Data Engineering', slug: 'data-engineering'},
  {name: 'Data Management', slug: 'data-management'},
  {name: 'Data Science', slug: 'data-science'},
  {name: 'Cloud Computing', slug: 'cloud-computing'}
];

export const GCC_ODC_TABS: ManagedServiceTab[] = [
  {name: 'ODC Setup & Scaling', slug: 'odc-setup-scaling'},
  {name: 'GCC Capability Development', slug: 'gcc-capability-development'},
  {name: 'Dedicated Engineering Teams', slug: 'dedicated-engineering-teams'},
  {name: 'Operating Model Evolution', slug: 'operating-model-evolution'}
];

export const STAFFING_TABS: ManagedServiceTab[] = [
  {name: 'Staffing Services', slug: 'staffing-services'},
  {name: 'Staffing Industries', slug: 'staffing-industries'},
  {name: 'IT Training', slug: 'it-training'},
  {name: 'Program Schedule', slug: 'program-schedule'}
];

// Returns the 1-based tab index for a URL param. Old display-name URLs still resolve; unknown values fall back to tab 1.
export function getTabIndex(tabs: ManagedServiceTab[], param: string): number {
  const index = tabs.findIndex((tab) => tab.slug === param || tab.name === param);
  return index === -1 ? 1 : index + 1;
}
